import { render, staticRenderFns } from "./Workstations.vue?vue&type=template&id=2862f8f6"
import script from "./Workstations.vue?vue&type=script&lang=js"
export * from "./Workstations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2862f8f6')) {
      api.createRecord('2862f8f6', component.options)
    } else {
      api.reload('2862f8f6', component.options)
    }
    module.hot.accept("./Workstations.vue?vue&type=template&id=2862f8f6", function () {
      api.rerender('2862f8f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Workstations/Workstations.vue"
export default component.exports